<template>
  <!-- Company Type Section -->
  <div class="section-container">
    <div
      class="section-title d-flex align-center px-6 py-3 subtitle-1 font-weight-medium"
    >
      <v-icon color="#FF6B35" class="mr-2">mdi-domain</v-icon>
      <span>{{ $t("company_type") }}</span>
    </div>
    <v-divider></v-divider>
    <div class="px-5 pt-5">
      <div class="flex-grow-1 full-width">
        <v-radio-group v-model="model.contract" class="radio-group mt-0">
          <v-radio
            :value="1"
            :label="$t('company_with_contract')"
            color="#FF6B35"
            class="ma-1"
          />
          <v-radio
            :value="0"
            :label="$t('company_without_contract')"
            color="#FF6B35"
            class="ma-1"
          />
          <v-radio :value="2" :label="$t('dining_hall')" color="#FF6B35" class="ma-1" />
          <v-radio :value="3" :label="$t('b2b')" color="#FF6B35" class="ma-1" />
          <v-radio
            :value="4"
            :label="$t('multi_restaurant_contracts')"
            color="#FF6B35"
            class="ma-1"
          />
        </v-radio-group>
      </div>
    </div>
  </div>
</template>

<script>
import hasModel from "@/mixins/hasModel.js";
import hasValidation from "@/mixins/hasValidation.js";

export default {
  mixins: [hasModel, hasValidation],
};
</script>

<style scoped>
/* Component specific styles if needed */
</style>
